import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NotFound.scss';
import SEO from '../../components/SEO';
const NotFound = () => {
    const { t } = useTranslation();

    return (
        <div className="kanem-404-page">
            <SEO title="Page introuvable" description="La page que vous cherchez n'existe pas." url="/404" />

            <div className="kanem-grain"></div>
            <div className="kanem-404-inner">
                <h1 className="kanem-404-number">404</h1>
                <h2>{t('notfound.title')}</h2>
                <p>{t('notfound.desc')}</p>
                <div className="kanem-404-actions">
                    <Link to="/" className="kanem-cta-btn">{t('notfound.cta')} →</Link>
                    <Link to="/contact" className="kanem-404-contact">{t('notfound.contact')}</Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
